import { getAnalyticsClickHandler } from '@eventbrite/legacy-infra.site-analytics';
import { defineMessage } from 'react-intl';
import {
    ACTION_HELP_LINK_CLICK,
    ACTION_HELP_LINK_HOVER,
    CATEGORY_HEADER,
} from '../constants/tracking';
import { ANCHOR_LINK } from '@eventbrite/legacy-eds.nav-list-item/constants';

/**
 * Retrieves the help menu info typically passed to the `additionalMenus` prop of the EDS Global Header
 * @param {object} helpUrls
 * @param {string} helpUrls.home
 * @param {UrlInfo[]} helpUrls.suggested
 * @param {string} [requestPath] Current request path (for analytics)
 * @returns object
 */
export const getHelpMenu = ({ home, suggested }, requestPath) => {
    const suggestedHelpMenuItems = suggested.map(({ url, label, gaLabel }) => ({
        type: ANCHOR_LINK,
        path: url,
        content: label,
        onClick: getAnalyticsClickHandler({
            requestPath,
            action: ACTION_HELP_LINK_CLICK,
            category: CATEGORY_HEADER,
            label: gaLabel,
        }),
        onMouseLeave: getAnalyticsClickHandler({
            category: CATEGORY_HEADER,
            action: ACTION_HELP_LINK_HOVER,
            label: gaLabel,
        }),
    }));

    const navItems = [...suggestedHelpMenuItems];

    return {
        label: defineMessage({ id: 'Help', defaultMessage: 'Help' }),
        fallbackUrl: home,
        navItems,
    };
};
